import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WidgetInfo } from 'src/app/interfaces/widget-info';
import { WidgetPanelCounts } from 'src/app/interfaces/widget-panel-counts';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-reviewing-vendors-widget',
  templateUrl: './reviewing-vendors-widget.component.html',
  styleUrls: ['./reviewing-vendors-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReviewingVendorsWidgetComponent {
  constructor(private ToastService: ToastService) {}

  @Input() widgetInfo?: WidgetInfo;

  widgetPanelCounts?: WidgetPanelCounts;

  ngOnInit(): void {
    if (!this.widgetInfo) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing reviewing widget data.',
        { returnError: true }
      );
    }

    this.widgetPanelCounts = {
      title: 'Reviewing Vendors',
      hasData: false,
      data: this.widgetInfo.data as Map<string, number>
    };
  }
}
